import React, { useContext, useState } from "react";
import "./style.css";
import logo from "../../../Assets/Images/Logo.png";
import logoDark from "../../../Assets/icons/Sidebaricon/Logo Dark.svg";
import back from "../../../Assets/icons/move-right.svg";
import backDark from "../../../Assets/icons/move-right-dark.svg";
import { Form, Input, Button, message } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../Contexts/ThemeProvider";
import { forgotPassword } from "../../../API/auth";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const { isDarkMode } = useContext(ThemeContext);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await forgotPassword(values?.email);

      if (Math.floor(response.status / 100) === 2) {
        navigate("/reset");
      } else {
        // show error
        message.error("Invalid Email!");
      }
    } catch (error) {
      console.error("Failed to perform the necessary action", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="logo">
        <img src={isDarkMode ? logoDark : logo} alt="Company Logo" />
      </div>

      <div className="forgot">
        <div className="forgot-card">
          <Button
            type="text"
            icon={
              <img
                src={isDarkMode ? backDark : back}
                alt="Back"
                className="back-icon"
              />
            }
            onClick={() => navigate("/login")}
            className="back-button"
          >
            Back
          </Button>

          <div className="title">
            <div className="main">Forgot Password?</div>
            <div className="sub">
              Don’t worry! It happens. Please enter the email address linked
              with your account.
            </div>
          </div>

          <Form
            name="forgot"
            className="forgot-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <div className="placeholders-heading">Email Address</div>
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input
                type="email"
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="Enter email"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="forgot-form-button"
                loading={loading}
              >
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
